<template>
  <div class="log">
    <header>
      <p v-on:click="backHistory" style="padding-left: 0; " @click=""><img src="@/assets/img/back.png" alt=""></p>
      <!--<p style="padding-right: 2rem;color: #FFFFFF ">保存</p>-->
    </header>
    <div class="personalMain">
      <div  class="personalTop">
        <div class="personalTopNmae">
          <h3>{{list.name}}</h3>
          <p v-if="list.salary==1">1K-2K</p>
          <p v-else-if="list.salary==2">2K-4K</p>
          <p v-else-if="list.salary==3">4K-6K</p>
          <p v-else-if="list.salary==4">6K-8K</p>
          <p v-else-if="list.salary==5">8K-10K</p>
          <p v-else-if="list.salary==6">10K-15K</p>
          <p v-else-if="list.salary==7">15K-20K</p>
          <p v-else-if="list.salary==8">20K-25K</p>
          <p v-else-if="list.salary==9">25K-35K</p>
          <p v-else-if="list.salary==10">35K-50K</p>
          <p v-else-if="list.salary==11">50K-70K</p>
          <p v-else-if="list.salary==12">70K-100K</p>
          <p v-else-if="list.salary==13">100K以上</p>
        </div>

        <p class="personalTopP"><van-icon name="location-o" />
          <span>{{list.city}}</span>
          <!--<span><van-icon name="shop-o" /> {{list.work_year}}</span>-->
          <span class="recommendYear" v-if="list.work_year==1"><van-icon name="shop-o" />不限</span>
          <span class="recommendYear" v-else-if="list.work_year==2" ><van-icon name="shop-o" />1年以下</span>
          <span class="recommendYear" v-else-if="list.work_year==3" ><van-icon name="shop-o" />1-3年</span>
          <span class="recommendYear" v-else-if="list.work_year==4" ><van-icon name="shop-o" />3-5年</span>
          <span class="recommendYear" v-else-if="list.work_year==5" ><van-icon name="shop-o" />5-10年</span>
          <span class="recommendYear" v-else-if="list.work_year==6" ><van-icon name="shop-o" />10年以上</span>
          <!--<van-icon name="desktop-o" />-->
          <span v-if="list.edu==1">不限</span>
          <span v-else-if="list.edu==2">·1年以下</span>
          <span v-else-if="list.edu==3">·1-3年</span>
          <span v-else-if="list.edu==4">·3-5年</span>
          <span v-else-if="list.edu==5">·5-10年</span>
          <span v-else-if="list.edu==6">·10年以上</span>
        </p>
      </div>
      <div  class="personalTop">
      <div class="messageCenter">
        <div class="communicate">
          <img src="@/assets/img/2.jpg" alt="">
        </div>
        <div style="width: 78%;padding-left: 14px" class="">
          <div><span style="color:#639DD5">韩多多</span><span style="color:#BEBEBE;margin-left: 1rem;font-size: 12px ">十二栋</span></div>
          <div class="communicateRight">
            <span style="color:#BEBEBE "> 您好，有兴趣了解一下吗</span>
            <span style="color:#BEBEBE "> 2015</span>
          </div>
        </div>
      </div>
      </div>
      <div  class="personalTop">
        <h4>职位描述</h4>
        <p class="personalTopS">
          <!--<van-icon name="location-o" />-->
          <span>{{list.keywords}}</span>
          <span>
            <!--<van-icon name="shop-o" />-->
            电商</span>
          <!--<span><van-icon name="desktop-o" />本科</span>-->
        </p>

      </div>
      <div style="padding: 0 1rem;font-size: 14px">
        <p>职位类型：{{list.position_type}}
          <span v-if="list.work_nature==1">全职</span>
          <span v-else-if="list.work_nature==2">兼职</span>
          <span v-else-if="list.work_nature==3">实习</span>
        </p>
        <p>职位亮点：{{list.welfare}}</p>
        <p>职位类型：{{list.position_type}}</p>
        <p>岗位职责：</p>
        <!--<p>{{list.desc}}</p>-->
        <!--<pre class="desc">-->
         <!--{{list.desc}}-->
        <!--</pre>-->
        <p><van-field
          v-model="list.desc"
          rows="1"
          autosize
          type="textarea"
          placeholder="请输入留言"
        /></p>
        <!--<textarea style="width: 100%;height: 20rem;border: none">-->
        <!--职位类型：{{list.position_type}}-->
        <!--职位亮点：气氛好 福利多多-->
        <!--岗位职责:-->
        <!--1.根据产品需求主导服务端程序的设计和开发；-->
        <!--2.对新业务方向的相关方向提供开发和支持；-->
        <!--3.参与优化或重构现有系统，支撑业务进一步发展；-->
        <!--4.能够根据不同的业务需求，灵活快速的完成具有挑战行的项目。-->


        <!--任职要求:-->
        <!--1.根据产品需求主导服务端程序的设计和开发；-->
        <!--2.对新业务方向的相关方向提供开发和支持；-->
        <!--3.参与优化或重构现有系统，支撑业务进一步发展；-->
        <!--</textarea>-->
      </div>
    </div>
    <!--<div class="inforName">-->
      <!--<van-button style="width: 100%;margin: 0 auto" type="primary" @click="sendJober()">投递简历</van-button>-->

    <!--</div>-->
  </div>
</template>
<script>
  import {Toast} from 'vant';
  export default {
    name:'',
    data(){
      return {
        msg: "",
        list:{}
      }
    },
    mounted(){
//      this.getDetailsPositioner()
      this.getMessager1()
    },
    methods:{
      backHistory(){
        this.$router.go(-1)
      },
      getMessager1() { //职位信息
        this.$api.getComPosition({
          "jobid": 4
        })
          .then(res => {
//            if(res.status==200){
            this.list = res.data?res.data[0]:{}
          })
      },
      getDetailsPositioner(){
        this.$api.getDetailsPosition({
          "userid":localStorage.getItem("userid"),
          "id":this.$route.params.id
        })
          .then(res=>{
            this.list=res
          })
          .catch(res=>{
          })
      },
      sendJober(){
//        this.$toast("点击图标");
        Toast({
          message: '顶部展示',
          position: 'top',
        });

        this.$api.sendJob({
          "user_id":localStorage.getItem("userid"),
          "job_id":this.$route.params.id,
          "company_id":this.$route.params.cid
        })
          .then(res=>{
            if(res.status==200){
              Toast({
                message: '投递成功',
//                position: 'top',
              });
              this.$router.push("/position")
            }else if(res.status==300){
              Toast({
                message: res.data,
//                position: 'top',
              });
            }
          })
          .catch(res=>{
            Toast({
              message: '投递失败',
              position: 'top',
            });
          })
      }
    }
  }
</script>
<style scoped="">
  .personalTopNmae{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .personalTopNmae p{
    padding-right: 1rem;
    /*color:#07c160;*/
    color:#C46571;
    font-size: 18px;
  }
  header{
    width: 100%;
    height: 56px;
    background-color: #6e9bcf;
    position: fixed;
    top:0 ;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem;
    z-index: 100;
  }
  header img{
    width: 20px;
    height: 20px;
  }
  .personalMain{
    padding-top: 56px;
    /*padding: 8rem 18px;*/
    /*padding:  8rem 18px 0 18px;*/
  }
  .personalTop{
    /*border-top:solid 7px #dedede ;*/
    border-bottom:solid 7px #dedede ;
    padding: 0 1rem;
  }
  .personalTopP{
    font-size: 12px;
    color: grey;
  }
  .personalTopS{
    font-size:12px ;
  }
  .personalTopS span{
    background: #ececec;
    padding: 3px 8px;
    border-radius: 10px;
  }
  .inforName{
    position: fixed;
    bottom: 0;
    width: 100%;
  }
.recommendYear{
 margin-left: 2rem;
}
  .messageCenter{
    /*margin-top: 75px;*/
    display: flex;
    align-items: center;
    /*width: 85%;*/
    margin: auto;
    padding: 15px 0;
  }
  .communicate{
    width: 50px;
    height: 50px;
    /*border-radius:100% ;*/
  }
  .communicate img{
    width: 100%;
    /*width: 100%;*/
    border-radius: 100%;
  }
  .communicateRight{
    display: flex;
    /*display: flex;*/
    justify-content: space-between;
    padding-top: 6px;
    font-size: 1px;
  }
  .desc{
    padding: 20px 0;
    color: #6d6d6d;
    font-size: 14px;
    letter-spacing: 0.5px;
    white-space: pre-wrap;
    font-family: '微软雅黑';
  }
</style>



// WEBPACK FOOTER //
// src/components/firstMessageDetail.vue